import { render, staticRenderFns } from "./editMediaPublish.vue?vue&type=template&id=31c20f00&scoped=true&"
import script from "./editMediaPublish.vue?vue&type=script&lang=js&"
export * from "./editMediaPublish.vue?vue&type=script&lang=js&"
import style0 from "./editMediaPublish.vue?vue&type=style&index=0&id=31c20f00&lang=less&scoped=true&"
import style1 from "./editMediaPublish.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c20f00",
  null
  
)

component.options.__file = "editMediaPublish.vue"
export default component.exports